export default function DashboardVerifikatorSehatPage() {
  return <div>DashboardVerifikatorSehatPage</div>;
}
